import juImage from '../images/education/JU.png';
import smhImage from '../images/education/smh.png';
import ibmiImage from '../images/education/IBMI.png';
import hubspotImage from '../images/education/Hubspot.png';

const educationData = [
  {
    title: 'Jönköping Tekniska Högskola',
    image: juImage,
    period: 'Examen 2025',
    description:
      'Tog examen som dataingenjör med fokus på systemutveckling, mjukvaruarkitektur och praktiska projekt.',
    highlights: [
      'Programmeringsspråk: Python, Java, C++, Swift och Kotlin.',
      'Kurser inom projektledning, företagsekonomi och verksamhetsutveckling.',
      'Arbete i tvärfunktionella team med verklighetsnära case.',
    ],
  },
  {
    title: 'Sälj & Marknadshögskolan',
    image: smhImage,
    period: 'Hållbar affärsutveckling',
    description:
      'Fördjupning i hur hållbarhet integreras i affärsstrategi, marknad och ledarskap med starkt praktiskt fokus.',
    highlights: [
      'Case-arbeten med Coca-Cola, IKEA, Arla och H&M.',
      'Strategisk koppling mellan affärsmodell, ESG och FN:s globala mål.',
      'Sustainability reporting: KPI:er, styrning, transparens och intressentdialog.',
      'Multikanal-försäljning och Social Selling i hållbara erbjudanden.',
      'Strategisk projektledning med hållbarhet integrerad i genomförandet.',
    ],
  },
  {
    title: 'IBMI – International Business Management Institute',
    image: ibmiImage,
    period: 'Certifierad projektledare',
    description:
      'Internationell onlineutbildning med fokus på praktisk projektledning i föränderliga miljöer.',
    highlights: [
      'Riskhantering och förändringsledning.',
      'Ledarskap, teamutveckling och leveransstyrning.',
      'Struktur för att driva projekt från planering till genomförande.',
    ],
  },
  {
    title: 'HubSpot Academy',
    image: hubspotImage,
    period: 'Onlinekurs i Sales Management',
    description:
      'Utbildning i säljledning med fokus på operativ styrning, analys och långsiktiga kundrelationer.',
    highlights: [
      'Planering av säljprocesser och målstyrning.',
      'Performance-analys och optimering av säljarbetet.',
      'Relationsbyggande för hållbar affärstillväxt.',
    ],
  },
];

export default educationData;
